import { UserLocale } from '@mnd-frontend/graphql-schema';

export const localeOptions = [
  { value: UserLocale.En, label: 'English' },
  { value: UserLocale.Sv, label: 'Svenska' },
  { value: UserLocale.No, label: 'Norsk' },
  { value: UserLocale.Fi, label: 'Suomi' },
  { value: UserLocale.Da, label: 'Dansk' },
  { value: UserLocale.De, label: 'Deutsch' },
];

export const pressroomLocaleToUserLocale = (val: string): UserLocale => {
  switch (val.toLowerCase()) {
    case 'en':
      return UserLocale.En;
    case 'sv':
      return UserLocale.Sv;
    case 'de':
      return UserLocale.De;
    case 'da':
      return UserLocale.Da;
    case 'fi':
      return UserLocale.Fi;
    case 'no':
      return UserLocale.No;
    default:
      return UserLocale.En;
  }
};
